import React, { Component } from 'react';
import { connect } from 'react-redux'
import DateRange from '@mui/icons-material/DateRange';
import Delete from '@mui/icons-material/Delete';
import DatePickerUI from '../../DatePicker/DatePicker';
import Details, { DetailsItem, DetailsDivider } from '../../Details/Details';
import TextArea from '../../TextArea/TextArea';
import { ToggleTrigger, ToggleContainer } from '../../Toggler/Toggler';
import { Button } from '@mui/material';

const NUM_MAINTENANCE_DATES = 15;

class Maintenance extends Component {
	constructor(props) {
		super(props);
		let paddedData = [];
		for (let i = 0; i < NUM_MAINTENANCE_DATES; i++) {
			if (this.props.maintenance_data[i]) {
				paddedData.push(this.props.maintenance_data[i])
			} else {
				paddedData.push({
					maintenance_date: null,
					maintenance_description: null
				})
			}
		}
		this.state = { paddedData }
	}
	updateState(index, dutchDate, description) {
		let updatedData = this.state.paddedData.slice(0);
		updatedData[index].maintenance_date = dutchDate;
		if (description !== undefined) {
			updatedData[index].maintenance_description = description;
		}
		this.setState({paddedData: updatedData});
	}
	getIndex(elementId) { // Gets the element’s index by finding the number in the element’s id, ex: 0-maintenance_date => [0, 'maintenance_date'][0])
		return parseInt(elementId.split(`-`)[0], 10)
	}
	copyDateFromPreviousRow(event) {
		const myIndex = this.getIndex(event.currentTarget.id);
		const targetIndex = myIndex - 1 < 0 ? 0 : myIndex - 1;
		const copiedDate = this.state.paddedData[targetIndex].maintenance_date;
		this.updateState(myIndex, copiedDate);
	}
	handleDateChange(instance, date) {
		const index = this.getIndex(instance.props.id);
		this.updateState(index, date.format('DD-MM-YYYY'));
	}
	deleteRow(event) {
		const myIndex = this.getIndex(event.currentTarget.id);
		this.updateState(myIndex, null, '');
	}
	render() {
		const items = this.state.paddedData.map((item, index) => (
			<div key={index}>
				<Details header={`${this.props.t.finish_execute} ${index + 1}`} primary={true}>
					<div className="grid-inline grid-block-portrait">
						<DetailsItem label={this.props.t.date}>
							<DatePickerUI
								t={this.props.t}
								clearable="true"
								data-notrequired
								className="spacing-default-right"
								label={this.props.t.select_date}
								id={`${index}-maintenance_date`}
								name={`${index}-maintenance_date`}
								value={item.maintenance_date}
								onChange={this.handleDateChange.bind(this)} />
						</DetailsItem>
						{index > 0 && // Don't render on first row
						<DetailsItem>
							<Button
								variant="contained"
								id={`${index}-copy-date`}
								className="grid-block spacing-default-right"
								onClick={this.copyDateFromPreviousRow.bind(this)}
								color="secondary"
							>
								<DateRange style={{ marginRight: 8 }} />
								{this.props.t.maintenance_copy_date}
							</Button>
						</DetailsItem>
						}
						<DetailsItem>
							<Button
								variant="contained"
								id={`${index}-delete-row`}
								className="grid-block spacing-default-right"
								onClick={this.deleteRow.bind(this)}
								color="secondary"
							>
								<Delete style={{ marginRight: 8 }} />
								{this.props.t.delete}
							</Button>
						</DetailsItem>
						<DetailsItem>
							{/* TODO: Notes label is not translated due to implementation of "Opmerkingen" in routes/inpection.js */}
							<ToggleTrigger
								id={`${index}-description-trigger`}
								targetId={`${index}-description-notes`}
								active={!!item.maintenance_description}
								className="grid-block" />
						</DetailsItem>
					</div>
					<DetailsItem>
						<ToggleContainer id={`${index}-description-notes`}>
							<TextArea
								data-notrequired
								className="text-area spacing-default-bottom"
								name={`${index}-maintenance_description`}
								triggerId={`${index}-description-trigger`}
								value={item.maintenance_description}
								floatingLabelText={this.props.t.notes} />
						</ToggleContainer>
					</DetailsItem>
				</Details>
				<DetailsDivider />
			</div>
		))
		return (
			<div className="inspection-part">
				{items}
			</div>
		);
	}
}
function mapStateToProps (state) {
	const { t } = state.store
	return { t }
}
export default connect(mapStateToProps)(Maintenance)

